import React from "react";
import { RouteComponentProps, withRouter } from "react-router";
import { Icon } from "@cadmakers-ui/icons";
import iconStyles from "../../../../Common/Styles/Icons.module.scss";
import { appPaths } from "../../../../Common";
import { BadgeButton } from "../../../../Layout/Components/BadgeButton/BadgeButton";
import { Topic } from "../../../../Topic/Models/Topic";
import ElementSpacer from "../../../../Layout/Components/ElementSpacer";

type Props = {
  topic: Topic;
};

class FeedbackTopicBadge extends React.Component<Props & RouteComponentProps> {
  onClick = () => {
    this.props.history.push(
      appPaths.topic.featureRequests.replace(":topicCode", this.props.topic.code)
    );
  };

  render() {
    return (
      <BadgeButton
        onClick={this.onClick}
        title={`Click here to see all feedback for ${this.props.topic.name}`}
      >
        <ElementSpacer spacing=".25rem">
          <span>
            <Icon
              appName="GeneralLayout"
              assetName="GENERAL_F_ListView"
              className={iconStyles.smallIcon}
            />
          </span>
          {this.props.topic.name}
        </ElementSpacer>
      </BadgeButton>
    );
  }
}

export default withRouter(FeedbackTopicBadge);
